/**
 * Owner: Masa Bayu
 * File: text-element.ts
 * Date:Time: 2026-09-05 06:59
 * Description: Domain factory for QXW text elements.
 */
import { QX_DEFAULT_TEXT_LAYOUT } from './element-layout';
import { QX_ELEMENT_VERSION } from './element-type';
import { createQXId } from './id';
import { createQXTextContent } from './text-model';
export function createQXTextElement(options = {}) {
    return {
        id: options.id ?? createQXId('el'),
        type: 'text',
        version: QX_ELEMENT_VERSION,
        name: options.name ?? 'Text',
        layout: { ...QX_DEFAULT_TEXT_LAYOUT },
        style: {},
        content: createQXTextContent(options.text ?? ''),
        responsive: {},
        animationIds: [],
        interactionIds: [],
        accessibility: {},
        locked: false,
        visible: true,
    };
}
//# sourceMappingURL=text-element.js.map